import moment from 'moment';
import { ISeasonAward } from '../../../store/admin/seasonAwards/store';

export const awardDate = (award: ISeasonAward) => moment(award.created).format('MM/DD/YY');
